import definition from './notifications.service';

export default {
    name: 'NotificationsApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/notifications/index.js